import { bcs } from "@iota/iota-sdk/bcs";
const DummyFieldBcs = bcs.struct("DummyFieldObj", {
  dummy_field: bcs.bool()
});
const NameBcs = bcs.struct("Name", {
  labels: bcs.vector(bcs.string())
});
const RangeBcs = bcs.struct("Range", {
  from: bcs.u8(),
  to: bcs.u8()
});
const CouponRulesBcs = bcs.struct("CouponRules", {
  length: bcs.option(RangeBcs),
  available_claims: bcs.option(bcs.u64()),
  user: bcs.option(bcs.Address),
  expiration: bcs.option(bcs.u64()),
  years: bcs.option(RangeBcs),
  can_stack: bcs.bool()
});
const CouponHouseBcs = bcs.struct("CouponHouse", {
  coupons: bcs.struct("Coupons", {
    coupons: bcs.struct("Table", {
      id: bcs.struct("UID", {
        id: bcs.struct("ID", {
          bytes: bcs.Address
        })
      }),
      size: bcs.u64()
    })
  }),
  version: bcs.u8(),
  id: bcs.struct("UID", {
    id: bcs.struct("ID", {
      bytes: bcs.Address
    })
  })
});
const CouponBcs = bcs.struct("Coupon", {
  kind: bcs.u8(),
  amount: bcs.u64(),
  rules: CouponRulesBcs
});
export {
  CouponBcs,
  CouponHouseBcs,
  DummyFieldBcs,
  NameBcs
};
//# sourceMappingURL=bcs.js.map
